export default {
	activity: {
		create: "Neue Aktivität",
		edit: "Aktivität bearbeiten",
		name: "Aktivitätsname",
		dataobject: "Verknüpftes Datenobjekt",
		dataobjectHint: "Das Datenobjekt, mit dem diese Aktivität arbeitet.",
		actions: {
			empty: {
				title: "Noch keine Aktionen",
				hint: "Ziehen Sie ein Element aus dem Panel „Elemente“ auf die Leinwand, um eine Aktion hinzuzufügen.",
			},
		},
		empty: {
			title: "Noch keine Aktivitäten",
			hint: "Erstellen Sie eine Aktivität, um zu modellieren, was mit einem Datenobjekt geschieht.",
		},
		typePicker: {
			primitives: "Grundtypen",
			arrays: "Listen",
			types: "Typen",
			dataobjects: "Datenobjekte",
			builtIn: "Eingebaut",
		},
		canvas: {
			removeConnection: "Verbindung entfernen",
			zoomIn: "Vergrößern",
			zoomOut: "Verkleinern",
			fitView: "Alles einpassen",
			// Ein Wert, den ein Knoten mit dem Namen seines Felds zeigt, etwa „Attribut: street“.
			labelledValue: "{label}: {value}",
		},
		// Die Tag-Gruppen der Übersicht: benannte Mengen von Tags, nach denen sie die Aktivitäten gruppiert.
		tagGroups: {
			groupBy: "Gruppieren nach",
			groupNone: "Keine",
			groupTags: "Tag-Gruppen",
			groupDataobject: "Datenobjekt",
			edit: "Gruppen bearbeiten",
			collapseAll: "Alle einklappen",
			expandAll: "Alle ausklappen",
			// Der Abschnitt der Aktivitäten, die keine Gruppe aufnimmt.
			loose: "In keiner Gruppe",
			countOf: "{count} von {total}",
			empty: "Noch keine Aktivität hat einen dieser Tags.",
			// Auf einer Karte in einer Gruppe: die anderen Gruppen, in denen sie auch steht.
			alsoIn: "Auch in {groups}",
			noMatchIn: "Kein Treffer in {sections}.",
			noneYet: "Noch keine Tag-Gruppen",
			noneYetHint:
				"Eine Gruppe sammelt jede Aktivität, die einen ihrer Tags hat. Alle im Projekt sehen dieselben Gruppen.",
			title: "Tag-Gruppen",
			note: "Eine Aktivität steht in jeder Gruppe, zu der einer ihrer Tags gehört. Ziehen Sie eine Gruppe, um die Reihenfolge zu ändern.",
			none: "Noch keine Gruppen.",
			name: "Name",
			nameEmpty: "Geben Sie der Gruppe einen Namen.",
			nameTaken: "Eine andere Gruppe hat diesen Namen.",
			// Tags einer Gruppe, die keine Aktivität (mehr) hat. Sie bleiben, damit sich die Gruppe nicht von selbst ändert.
			unused: "Keine Aktivität hat: {tags}",
			count: "Keine Aktivitäten | 1 Aktivität | {count} Aktivitäten",
			remove: "{name} entfernen",
			unnamed: "unbenannte Gruppe",
			add: "Neue Gruppe",
			leftOver: "Tags in keiner Gruppe",
			leftOverHint: "Ziehen Sie einen auf eine Gruppe, oder klicken Sie ihn an.",
			leftOverHintNoGroups: "Ziehen Sie einen auf „Neue Gruppe“, oder klicken Sie ihn an.",
			// Ein Tag unter „Tags in keiner Gruppe“, wie sein Button ihn nennt; er öffnet das Menü der Gruppen.
			addTag: "{tag} einer Gruppe hinzufügen (1 Aktivität) | {tag} einer Gruppe hinzufügen ({count} Aktivitäten)",
			newWithTag: "Neue Gruppe mit diesem Tag",
			loadFailed:
				"Die Tag-Gruppen konnten nicht geladen werden, daher kann die Liste nicht nach ihnen gruppiert werden.",
		},
		noResults: "Keine Aktivitäten entsprechen Ihrer Suche.",
		dataobjectRequired: "Wählen Sie ein Datenobjekt.",
		deleteConfirm: "Aktivität „{name}“ löschen?",
		deletedRemotely: "Diese Aktivität wurde von einer anderen Person gelöscht.",
		// Der Name, den eine duplizierte Aktion erhält. Er wird gespeichert, steht also in
		// der Sprache der Person, die dupliziert hat — freier Text ohnehin, und schneller
		// umbenannt als erklärt.
		copyName: "{name} Kopie",
		duplicateShortcut: "Die ausgewählte Aktion duplizieren",

		import: {
			open: "Aus einer anderen Aktivität importieren",
			title: "Aktion aus einer anderen Aktivität importieren",
			search: "Aktionen und Aktivitäten suchen…",
			loading: "Aktivitäten des Projekts werden geladen…",
			empty: "Noch keine andere Aktivität dieses Projekts hat Aktionen.",
			noMatches: "Keine Aktion entspricht Ihrer Suche.",
			blockedHeading: "Nicht für dieses Datenobjekt",
			// Warum eine Zeile nicht wählbar ist — benennt das Attribut, das ihr fehlt.
			blocked: "benötigt {attribute}",
		},

		// Die Elementtypen der Palette, nach Anzeigename. Der NAME eines neuen Knotens ist das
		// englische `label` der Registry und wird gespeichert — dies hier benennt nur den Typ.
		elements: {
			categories: {
				tasks: "Aufgaben",
				data: "Daten",
				events: "Ereignisse",
				alternis: "Alternis",
				telephony: "Telefonie",
				time: "Zeit",
				process: "Prozess",
				interactables: "Interaktive Elemente",
			},
			types: {
				CUSTOM_ACTION: "Eigene Aktion",
				CLIENT_SCRIPT: "Client-Skript",
				ATTRIBUTE_LISTENER: "Attribut beobachten",
				ATTRIBUTE_WRITER: "Attribut schreiben",
				EVENT_LISTENER: "Ereignis empfangen",
				EVENT_EMITTER: "Ereignis senden",
				LIFECYCLE_HOOK: "Lebenszyklus-Ereignis",
				ALTERNIS_SEND_MESSAGE: "Alternis: Nachricht senden",
				ALTERNIS_SEND_PREFAB: "Alternis: Prefab senden",
				ALTERNIS_ON_SESSIONS: "Alternis: Sitzungsereignisse",
				ALTERNIS_ON_MESSAGES: "Alternis: Nachrichtenereignisse",
				EMIT_NOTIFICATION: "Benachrichtigung anzeigen",
				EMIT_ATTRIBUTE_SUGGESTION: "Attributvorschlag anzeigen",
				EMIT_TAB: "Tab anzeigen",
				EMIT_ALTERNIS_CHAT: "Alternis-Chat anzeigen",
				EMIT_QUESTION: "Frage stellen",
				EMIT_QUESTION_TAB: "Fragen-Tab anzeigen",
				EMIT_PANEL: "Panel anzeigen",
				REMOVE_QUESTION_TAB: "Fragen-Tab entfernen",
				SET_QUESTION_PRIORITY: "Fragenpriorität setzen",
				LOG: "Log-Eintrag schreiben",
				CONFIGURE_SUGGESTIONS: "Vorschläge konfigurieren",
				VOICEBOT: "Voicebot",
				SIP_ON_CALLS: "SIP: Anrufereignisse",
				SIP_CALL_CONTROL: "SIP: Anruf steuern",
				DATAOBJECT_OPERATION: "Datenobjekt-Operation",
				TICKER: "Ticker",
				TIMER: "Timer",
				ON_TIME: "Zu einer Zeit",
				SPAWN_PROCESS: "Prozess starten",
				SEND_EVENT_TO_PROCESS: "Ereignis an Prozess senden",
				PROCESS_CONTROL: "Prozess steuern",
				LIST_PROCESSES: "Prozesse auflisten",
				PROCESS_ACCESS: "Prozess freigeben",
				LIST_USERS: "Benutzer auflisten",
			},
			// The Elements panel's tiles that create a type preconfigured (ActionPreset).
			presets: {
				graphly: "Graphly",
				lumina: "Lumina",
				question_list: "Fragenliste",
				suggestion_pool: "Vorschlagspool",
			},
		},

		sidebar: {
			// Ein Kontrollkästchen für die Aktionen, die dem Operator melden, wenn sie fehlschlagen.
			notifyOnFailure: {
				title: "Bei einem Fehler",
				label: "Benachrichtigung anzeigen",
				hint: "Aus: Es wird nichts angezeigt, und der Fehler ist Sache des Modells — ok am Ausgang ist false, und error nennt den Grund.",
			},
			usages: {
				title: "Anderswo verwendet",
				here: "In dieser Aktivität",
				noneEvent: "Keine andere Aktion sendet oder empfängt dieses Ereignis.",
				noneAttribute:
					"Keine andere Aktion schreibt, beobachtet, liest oder schlägt dieses Attribut vor.",
				badge: {
					listeners: "Von {n} Aktion empfangen | Von {n} Aktionen empfangen",
					emitters: "Von {n} Aktion gesendet | Von {n} Aktionen gesendet",
				},
				codeNotRead: "Der Code eigener Aktionen wird nicht durchsucht.",
				roles: {
					emits: "sendet",
					listens: "empfängt",
					/* Ein Attribut wird beobachtet, nicht empfangen: die Zeile eines ATTRIBUTE_LISTENER. */
					watches: "beobachtet",
					writes: "schreibt",
					reads: "liest",
					suggests: "schlägt vor",
				},
			},
			elements: "Elemente",
			searchElements: "Elemente suchen…",
			readOnlyHint: "Sie können diese Aktivität ansehen, aber nicht ändern.",
			// Ein Schreiber, den eine Frage für einen ihrer attributgebundenen Eingänge verwaltet.
			managedHint:
				"Für die Frage „{question}“ angelegt. Was sie schreibt, legen Sie an der Frage fest; hier können Sie die Aktion umbenennen, beschreiben, verschieben und umfärben.",
			// Die Ausgänge eines VOICEBOT nach dem Zustand: was er entschieden hat, damit der Prozess handeln kann — und die Sitzung, in der er spricht, die keine Entscheidung ist, sondern eine ID zum Aufbewahren.
			voicebotEventsHint:
				"Die Ausgänge von „handoff“ bis „failed“ melden jeweils etwas, das der Voicebot entschieden hat. Ist „handoff“ verbunden, entfällt die Benachrichtigung an den Operator: Was daran hängt, übernimmt das Gespräch. „session“ ist die Alternis-Sitzung, in der der Voicebot spricht: Verbinden Sie diesen Ausgang mit einer Aktion „Attribut schreiben“ für ein Text-Attribut namens session_id, das jede Alternis-Aktion standardmäßig liest.",
			configuration: "Konfiguration",
			optionalLabel: "{label} (optional)",
			clearColor: "Zurücksetzen",
			known: "Hier verwendet:",
			groups: {
				content: "Inhalt",
				placement: "Platzierung",
				appearance: "Darstellung",
				behaviour: "Verhalten",
				actors: "Wer handeln darf",
				session: "Sitzung",
				chat: "Chat",
				voice: "Stimme",
				telephony: "Telefonanruf (SIP)",
				location: "Ortsdienst",
				gateway: "LLM-Gateway",
				advanced: "Erweitert",
			},
			iconPicker: {
				empty: "Kein Icon passt.",
				clear: "{label} leeren",
			},
			poolEntries: {
				kind: "Wofür die Karte steht",
				attribute: "Attribut",
				question: "Fragefeld",
				remove: "Karte entfernen",
				attributeLabel: "Attribut",
				attributePlaceholder: "Attribut auswählen…",
				questionLabel: "Fragen-ID",
				questionPlaceholder: "z. B. ask-name",
				inputLabel: "Name des Felds",
				inputPlaceholder: "z. B. name",
				before: "Anzeigen, bevor es einen Vorschlag gibt",
				after: "Behalten, nachdem der Wert übernommen wurde",
				title: "Titel",
				titlePlaceholder: "Leer gelassen, benennt der Operator die Karte",
				icon: "Icon",
				incomplete:
					"Wählen Sie, wofür die Karte steht — bis dahin wird sie nicht gespeichert.",
				repeated: "Eine andere Karte steht für dasselbe.",
				none: "Keine Karten — der Pool zeigt nur die offenen Vorschläge.",
				add: "Karte hinzufügen",
			},
			chatRoles: {
				role: "Rolle",
				label: "Name",
				labelPlaceholder: "z. B. Leitstelle",
				icon: "Icon",
				color: "Farbe",
				clearColor: "Eigene Farbe des Chats verwenden",
				remove: "Rolle entfernen",
				numberInvalid: "Eine Rollennummer ist eine ganze Zahl von 0 bis 255.",
				repeated: "Diese Rolle ist schon benannt.",
				incomplete:
					"Geben Sie eine Nummer und einen Namen ein — bis dahin wird diese Rolle nicht gespeichert.",
				none: "Keine Rollen benannt — der Chat verwendet seine eigenen Wörter dafür.",
				add: "Rolle hinzufügen",
				addOwn: "Bot und Anrufer hinzufügen",
			},
			hints: {
				suggestionValue:
					"Was der Vorschlag anbietet: der Wert eines Eingangs oder eines seiner Felder, ein fester Wert, eine Umgebungsvariable oder ein Attribut. Leer gelassen, schlägt er den Wert seines ersten Eingangs vor.",
				poolEntries:
					"Karten, die der Pool behält, ob es einen Vorschlag gibt oder nicht — ein Attribut oder ein Feld einer Frage —, in der hier gezeigten Reihenfolge. Eine Karte kann leer erscheinen, bevor ein Vorschlag eintrifft, und bleiben, nachdem ihr Wert übernommen wurde.",
				chatRoles:
					"Wie der Chat jede Rollennummer nennt, das Icon daneben und die Farbe, in der ihre Nachrichten erscheinen. Rolle 0 ist der Disponent — bei einem Voicebot der Bot —, die anderen Nummern sind, wen die Sitzung nennt. Eine Rolle ohne Namen erscheint als „Disponent“ oder „Anrufer“, eine ohne Farbe in der eigenen Farbe des Chats für ihre Nummer.",
				emitImmediately:
					"Sobald die gesprochene Fassung der Nachricht fertig ist, wird sie sofort abgespielt. Aus: Jemand startet sie im Chat.",
				freezeText:
					"Angezeigter Text folgt normalerweise den Attributen, die er liest. Eingefroren bleibt er, wie er beim Anzeigen war.",
				interactableId:
					"Kennzeichnet, was angezeigt wird, damit eine spätere Aktion es aktualisieren oder entfernen kann. Dieselbe ID erneut anzuzeigen aktualisiert es an Ort und Stelle.",
				notificationTitle:
					"Ein paar Worte über dem Text, worum es geht. Leer gelassen, steht der Text allein.",
				notificationBody:
					"Leer gelassen, zeigt die Benachrichtigung den Wert ihres ersten Eingangs.",
				notificationSeverity:
					"Wie ein Operator sie sieht: unter 2 eine Information, 2 und 3 eine Warnung, ab 4 ein Fehler. Ein Fehler wird vor allen anderen wartenden Benachrichtigungen angezeigt.",
				tabAddress:
					"Was der Tab öffnet. Leer gelassen, zeigt der Tab den Wert seines ersten Eingangs.",
				onDismiss:
					"Ob es jemand mit dem ✕ daneben entfernen kann. Standard: Ein Tab oder eine Benachrichtigung lässt sich entfernen, ein Panel oder ein Chat nicht. „Ja, entfernen“: für alle entfernt. „Ja, Ausgang auslösen“: Die Aktion erhält einen Ausgang „geschlossen“, und es bleibt, bis eine andere Aktion es entfernt. Ein entfernter Chat bleibt weg, solange seine Sitzung dauert.",
				panelColumn:
					"In welcher Spalte des Operators es erscheint. Zwei Panels in derselben Spalte und Ausrichtung erscheinen als Tabs, und eine Spalte ohne Inhalt nimmt keinen Platz ein.",
				panelAlign:
					"Ob es oben oder unten in seiner Spalte erscheint. Allein in seiner Spalte füllt es sie aus.",
				chatTitle:
					"Wie der Chat heißt, wo er sich seinen Platz mit einem anderen Panel teilt, als Tab: ein fester Text, ein Attribut oder eine Umgebungsvariable. Leer gelassen, heißt er nach seiner Sitzung.",
				panelTitle: "Leer gelassen, benennt der Operator das Panel selbst.",
				panelId:
					"Leer gelassen, ist das Panel panel::graphly, panel::lumina oder panel::question_list — die ID, die auch das eigene Panel eines Legacy-Prozesses hat, sodass dieses umbenannt wird statt ein zweites hinzuzufügen. Zwei Vorschlagspools brauchen je eine eigene ID, sonst verschiebt der zweite den ersten.",
				voiceProvider:
					"Bevorzugt für die Textnachrichten dieser Aktion — die des Operators und die eigene Sprache eines Voicebots. Hat dieser Anbieter keine Stimme für die Sprache, weicht Alternis auf einen anderen aus. Ein Prefab kann keine Stimme mitgeben.",
				voiceInstructions:
					"Wie der Satz gesprochen werden soll, z. B. „ruhig und langsam sprechen“. Nur VoxCPM. Darf Attribute lesen, keine Eingänge: Der Text wird bei jeder gesendeten Nachricht gelesen.",
				voiceMode:
					"Wie eine Frage gesprochen wird, die keine eigene Einstellung hat. „scripted“: ihr Text, Wort für Wort. „guided“: das LLM formuliert sie und deckt jedes offene Feld ab. „free“: das LLM darf sich mit dem Anrufer unterhalten, solange sie offen ist, und lenkt zurück. Standard: „scripted“.",
				offPath:
					"Was der Bot tut, wenn der Anrufer etwas sagt, das keine Antwort ist, bei einer Frage ohne eigene Einstellung. „acknowledge“: ein paar Worte, dann fragt er erneut. „answer“: das LLM antwortet anhand des System-Prompts und kehrt dann zur Frage zurück. „handoff“: der Operator wird benachrichtigt — oder, ist der Ausgang „handoff“ des Voicebots verbunden, was daran hängt — und die Frage zurückgestellt. Standard: „acknowledge“.",
				floorPolicy:
					"Wer sprechen darf, während der Bot spricht. „open“: Der Anrufer wird nie stummgeschaltet, eine Korrektur mitten im Satz wird gehört. „half_duplex“: nur stumm, solange der Bot einen Satz spricht. „strict“: stumm, solange der Bot beschäftigt ist, und nur beim Zuhören hörbar. Standard: „open“.",
				silenceTimeout:
					"Wie lange der Bot in Millisekunden zuhört, bevor er nachhakt: Er fragt erneut oder geht zur nächsten Frage über, wenn er sie oft genug gestellt hat. Leer ist 8000; 0 schaltet das Nachhaken ab.",
				reaskMax:
					"Wie oft eine Frage gestellt wird, die erste eingeschlossen, bevor sie zurückgestellt wird und der Bot weitergeht. Die eigene Einstellung einer Frage hat Vorrang. Leer ist 2.",
				greeting:
					"Wird einmal zu Beginn gesprochen, vor jeder Frage. Darf Attribute lesen, keine Eingänge: Der Text wird gelesen, wenn der Bot spricht.",
				closing:
					"Wird gesprochen, wenn nichts mehr zu fragen bleibt — alles beantwortet, zurückgestellt oder optional. Darf Attribute lesen, keine Eingänge.",
				questionScope:
					"Beschränkt den Bot auf die Fragen unter diesem Fragen-Tab. Leer gelten alle Fragen. Setzen Sie es, wenn sich zwei Voicebots einen Prozess teilen.",
				questionVoiceText:
					"Was der Voicebot sagt, wenn der Fragetext für den Bildschirm geschriebenes Markdown ist. Leer gelassen, spricht er den Text ohne sein Markdown.",
				questionVoiceMode:
					"Standard: die Sprechweise des Voicebots. „free“ beantwortet den Anrufer auch, wenn er abschweift, es sei denn, die Frage übergibt ihn an den Operator.",
				questionOffPath:
					"Was der Voicebot tut, wenn der Anrufer etwas sagt, das keine Antwort ist. Standard: die Einstellung des Voicebots.",
				questionReaskMax:
					"Wie oft der Voicebot diese Frage stellt, bevor er sie zurückstellt. Leer: die Einstellung des Voicebots.",
				questionReaskRephrase:
					"Ob die erneute Frage vom LLM anders formuliert oder Wort für Wort wiederholt wird. Standard: umformuliert, außer die Sprechweise ist „scripted“.",
				locationService:
					"Der Ortsdienst, der eine Orts-Eingabe beantwortet. Was hier gesetzt ist, hat Vorrang vor NOTITIA_LOCATION_SERVICE_URL. Er braucht einen laufenden Alternis-Chat — eine Aktion „Alternis: Nachrichtenereignisse“, einen Chat im Sitzungsmodus oder einen Voicebot —, um etwas zuordnen zu können.",
				locationRegion:
					"Beschränkt den Dienst optional auf eine Region, genau so geschrieben, wie der Dienst sie führt — Saarland, Thueringen, Baden-Wuerttemberg. Ein Name, den er nicht kennt, beschränkt nichts. Eine Orts-Eingabe kann ihre eigene setzen.",
				locationPhone:
					"Eine Telefonnummer, die mit jeder Anfrage gesendet wird. Der Dienst stuft Adressen nahe ihrer Vorwahl höher ein und filtert nie danach. Sie hat Vorrang vor der Nummer des Anrufers, die ein Voicebot sendet. Die Nummer ist ein personenbezogenes Datum.",
				locationPosition:
					"Breiten- und Längengrad einer gemessenen Position des Anrufers, etwa eines GPS-Signals oder des Standorts, den ein Notruf übermittelt. Beide werden mit jeder Anfrage gesendet, und der Dienst stuft Adressen nahe der Position höher ein. Er filtert nie danach. Bei jeder Ausführung der Aktion ersetzt die gelesene Position die vorige, und liest sie keine, wird keine gesendet. Die Position ist ein personenbezogenes Datum.",
				locationRadius:
					"Wie weit der Anrufer von der Position entfernt sein kann, in Metern, wie es die Messung angibt. Jede Adresse innerhalb dieses Radius gilt als nah. Ein Radius von höchstens 10 km (die Voreinstellung des Dienstes) gibt der Position Vorrang vor einer Telefonnummer; ohne Radius hat die Telefonnummer Vorrang.",
				suggestionsGateway:
					"Das LLM-Gateway, das Vorschläge aus dem Gespräch ableitet. Was hier gesetzt ist, hat Vorrang vor der Umgebung, und diese vor dem eigenen Gateway eines Voicebots.",
				suggestionsEnabled:
					"Abgewählt schaltet automatische Vorschläge ab. Angehakt entscheidet die Umgebung (NOTITIA_NO_AUTO_SUGGESTIONS).",
				questionTab:
					"Der Fragen-Tab, unter dem diese Frage erscheint. Leer gelassen, steht sie unter dem Standard-Tab.",
				questionGroup:
					"Fragen mit derselben Gruppe werden zusammen angezeigt. Leer gelassen, gruppieren sie sich nach ihrem Datenobjekt; „on-top“ zeigt die Gruppe über allen anderen.",
				questionPriority:
					"Höhere Werte werden zuerst angezeigt; leer ist 0. Wird der Wert aus einem Attribut gelesen, sortiert sich die Frage neu, wenn es sich ändert.",
				questionTabId:
					"Fragen nennen diese ID als ihren Tab. „default“ gestaltet den Standard-Tab.",
				removeQuestionTab: "Der Standard-Tab kann nicht entfernt werden.",
				chatSessionId:
					"Die Alternis-Sitzung, der der Chat folgt und die er zeigt. Leer bleibt der Chat leer, bis eine Sitzung gesetzt ist — aus einem Attribut, sobald es eine hat.",
				setQuestionPriority:
					"Überschreibt die eigene Priorität dieser Frage, solange sie angezeigt wird. Eine nicht angezeigte Frage bleibt unverändert.",
				sipNumbers:
					"Nur Anrufe an diese Nummern erreichen diese Aktion: mit Kommas oder Leerzeichen trennen, ein * am Ende passt auf jeden Rest (+4930123456*). Leer sind es alle Anrufe an den Dataspace. Welche Anrufe den Dataspace überhaupt erreichen, bestimmen die Nummern des Trunks in den Telefonie-Einstellungen des Dataspace.",
				sipAction:
					"Was diese Aktion tut, sobald ihre Eingänge vollständig sind. „hangup“ beendet einen Anruf oder weist einen ab, den noch niemand angenommen hat; „transfer“ leitet einen Anruf an eine andere Nummer weiter; „call“ ruft eine Nummer an. Die Einstellungen darunter richten sich danach.",
				sipCallId:
					"Der Anruf, auf den sich die Aktion bezieht. Ein Eingang trägt den ganzen Wert, den seine Quelle geschickt hat: Der eingehende Anruf einer Aktion „SIP: Anrufereignisse“ kommt also als Anruf an, nicht als seine ID. Die ID (callId) muss vorher in einer eigenen Aktion ausgelesen werden.",
				sipNumber:
					"Die Nummer, die gewählt wird oder an die der Anruf weitergeleitet wird: ein + und bis zu 15 Ziffern (+4930123456). Leer gelassen, gilt die Nebenstelle darunter.",
				sipExtension:
					"Eine Nebenstelle der Telefonanlage des Trunks; sie gilt, wenn die Nummer leer ist.",
				sipReference:
					"Freitext mit bis zu 128 Zeichen, den die Telefonanlage mit dem Anruf erhält.",
				sipStatus:
					"Der SIP-Status, mit dem ein noch nicht angenommener Anruf abgewiesen wird, von 300 bis 699 — 486 heißt besetzt, 603 abgelehnt. Leer ist 486. Ein bereits angenommener Anruf wird in jedem Fall beendet.",
				voicebotSessionId:
					"Die Alternis-Sitzung, in der der Bot spricht; ohne Anruf ist sie erforderlich. Bei einem Anruf über Notitia leer lassen: Der Bot legt die Sitzung selbst an und meldet sie an seinem Ausgang „session“. Bei einem Anruf über die Telefonanlage die Sitzung der Telefonanlage angeben.",
				voicebotCallId:
					"Der Telefonanruf, den dieser Bot annimmt. Gesetzt, wird er zum Bot für einen Anruf: Er wartet auf die ID des Anrufs, nimmt ihn dann an und spricht darin. Bei der Anbindung „notitia“ wird die Sitzungs-ID oben optional — der Bot legt die Alternis-Sitzung selbst an. Aus einem Eingang gelesen, stammt sie aus dem eingehenden Anruf einer Aktion „SIP: Anrufereignisse“ (ein Prozess kann beides sein); aus einer Umgebungsvariable, wenn diese Aktion für jeden Anruf einen eigenen Prozess startet. Die Eingänge, die den Anruf steuern — hangup, transfer und call —, werden auf dem Tab „Verknüpfung“ hinzugefügt.",
				alternisIntegration:
					"Wie der Anruf nach Alternis kommt. „coms_system“: Die Telefonanlage hat ihn schon dorthin gebracht, und der Bot nutzt die Sitzungs-ID oben. „notitia“: Der Bot legt die Sitzung selbst an, und der Server übermittelt den Ton. „auto“: was der Trunk in seinen Telefonie-Einstellungen sagt. Standard: „auto“.",
				bargeIn:
					"Was die Sprache des Anrufers mit einem Satz macht, den der Bot gerade spricht. „stop“: Der Satz wird abgebrochen, sobald der Anrufer die Karenzzeit lang gesprochen hat. „off“: Ein Satz wird immer zu Ende gesprochen. Bei „half_duplex“ oder „strict“ unter „Wer sprechen darf“ sollten Sie „off“ wählen — der Anrufer ist in Alternis stummgeschaltet, solange der Bot spricht, der Satz würde also wegen Sprache abgebrochen, die niemand hört. Standard: „stop“.",
				bargeInGraceMs:
					"Wie lange der Anrufer in Millisekunden sprechen muss, bevor es als Unterbrechung zählt. Leer ist 500. Ohne Wirkung, solange Barge-in aus ist.",
				bargeInDuck:
					"Dreht den Satz auf etwa ein Drittel der Lautstärke herunter, sobald der Anrufer zu sprechen beginnt, noch bevor es als Unterbrechung zählt. Endet die Sprache innerhalb der Karenzzeit, ist die Lautstärke wieder da; nichts geht verloren.",
				bargeInMinWords:
					"Bei einer Zahl über 0 wird der Satz zunächst nur leiser gestellt, und der Bot bricht ihn ab, sobald das Live-Transkript des Anrufers so viele Wörter enthält: „Ja“ unterbricht nicht, „Nein, warten Sie einen Moment“ schon. Leer ist 0: Die Karenzzeit entscheidet.",
				cueThinking:
					"Spielt in Schleife einen leisen Ton, solange der Bot noch nichts zu sagen hat, damit der Anrufer keine Stille hört. Abgewählt schaltet ihn aus.",
				cueListening:
					"Ein kurzer Ton, wenn der Bot dem Anrufer das Wort übergibt. Aus, solange nicht angehakt.",
				cueMute:
					"Töne, wenn der Anrufer stumm- und wieder hörbar geschaltet wird — bei „half_duplex“ und „strict“ unter „Wer sprechen darf“. Aus, solange nicht angehakt.",
				transferTarget:
					"Wohin ein Transfer geht, wenn der Eingang, der ihn auslöst, kein Ziel mitbringt — etwa ein direkt verbundener handoff-Ausgang: eine Nummer (+4930123456) oder eine Nebenstelle der Telefonanlage des Trunks.",
				locationCallerNumber:
					"Sendet die Telefonnummer des Anrufers mit jedem Orts-Vorschlag des Anrufs an den Ortsdienst, der dann Adressen nahe ihrer Vorwahl höher einstuft. Sie ist ein personenbezogenes Datum und deshalb aus, solange nicht angehakt. Mobil- und ausländische Nummern bewirken nichts. Eine in „Vorschläge konfigurieren“ gesetzte Telefonnummer hat Vorrang.",
				pathPrefix:
					"Ein Attributpfad wie address.street. Reagiert auf dieses Attribut und alles darunter, nur auf ganze Namen: address reagiert auf address.street, nicht auf addressbook. Leer: jeder Pfad.",
				changeKinds: "Leer: jede Art von Änderung.",
				excludeOrigins:
					"Änderungen von diesen lösen nichts aus. Leer lassen, damit alle auslösen; „Ein Axiom“ wählen, um das zu übergehen, was Axiome ableiten.",
				dataobjectOperation:
					"Was die Aktion mit Datenobjekten tut, sobald einer ihrer Eingänge auslöst. „done“ liefert die ID des Datenobjekts, „failed“ den Grund der Ablehnung.",
				operationConcept:
					"Die Art des Datenobjekts, das erzeugt wird. Es entsteht wie der Eintrag des Prozesses für diese Art.",
				operationTemplate:
					"Nach welchem Eintrag des Prozesses es erzeugt wird, anhand seines Namens. Leer: der erste Eintrag des Prozesses für dieses Datenobjekt.",
				operationPath:
					"Welches optionale oder listenwertige eingebettete Datenobjekt gefüllt wird, als Pfad durch einzelne eingebettete Datenobjekte.",
				operationRelation:
					"Eine der Beziehungen des Datenobjekts, auf das die Operation wirkt.",
				operationTargetId:
					"Die ID des Datenobjekts, das verknüpft oder gelöst wird, meist von einem Eingang gelesen.",
				operationData:
					"Die Werte, mit denen das neue Datenobjekt beginnt, als Objekt. Sie werden gesetzt, bevor etwas anderes davon erfährt.",
				operationOwnerId:
					"Das Datenobjekt, auf das die Operation wirkt. Leer: das Datenobjekt dieser Aktivität.",
				operationOwnerConcept:
					"Das Konzept des oben genannten Datenobjekts, gegen das die Beziehung oder die Einbettungsstelle geprüft wird.",
				tickerInterval:
					"Millisekunden zwischen den Takten, mindestens 10. Der erste Takt kommt nach einem Intervall, die Ausgabe ist der Zähler ab 1.",
				tickerLimit: "Nach so vielen Takten anhalten. Leer: nie von selbst anhalten.",
				timerTimeout:
					"Millisekunden bis zum Auslösen. Ist nichts mit dem Start verbunden, beginnt er mit dem Prozess; ein angehaltener und fortgesetzter Prozess behält die Frist und löst sofort aus, wenn sie verstrichen ist.",
				timerRetrigger:
					"Was ein Start mit einem bereits laufenden Timer macht. Ein neuer Wert an einem Eingang startet immer neu ab jetzt.",
				timerPassthrough:
					"Wenn aktiv, gibt der Timer nach Ablauf der Zeit den Wert weiter, den sein Start-Eingang erhalten hat, statt nichts: eine Verzögerung. Geben Sie dem Start-Eingang den Typ des Werts, um danach auf dessen Felder zuzugreifen. Ein Prozess, der dazwischen angehalten wird, behält den Wert.",
				onTimeSchedule:
					"Einmal: an genau einem Datum und einer Zeit. Täglich: jeden Tag zu einer Uhrzeit, an den gewählten Tagen.",
				onTimeAt:
					"Ein Datum mit Uhrzeit ohne Versatz wird in der Zeitzone unten gelesen. Leer: löst nie aus.",
				onTimeTime: "Die Uhrzeit, gelesen in der Zeitzone unten.",
				onTimeWeekdays: "Leer: jeden Tag.",
				onTimeTimezone:
					"Die Zone, in der die Zeit gelesen wird, beim Hinzufügen der Aktion aus diesem Browser übernommen. Standard: die des Servers.",
				spawnDefinition:
					"Der Prozess, der bei jedem Auslösen eines Eingangs der Aktion gestartet wird. Auch der Prozess, zu dem diese Aktion gehört, kann gewählt werden, wenn seine Berechtigungen es erlauben. Der Ausgang liefert den neuen Prozess oder den Grund der Ablehnung.",
				spawnName: "Wie der neue Prozess im Operator heißt. Leer: sein eigener Name.",
				spawnDescription: "Die Beschreibung des neuen Prozesses im Operator.",
				spawnRestartRule:
					"Was passiert, wenn der neue Prozess endet. Der Operator kann sie später ändern. Standard: nur auf Wunsch einer Person.",
				spawnSeed:
					"Die Datenobjekte, mit denen der neue Prozess startet, nur beim ersten Start. Den Wert auf einen Ausdruck umschalten und eine JSON-Liste von Objekten mit concept, optionalem template und data schreiben. Sie kann auch aus einem Eingang oder Attribut gelesen werden.",
				sendProcessId:
					"Ein Prozess anhand seiner Instanz-ID, meist aus einem Eingang gelesen. Entweder dies oder die Definition unten setzen, nicht beides.",
				sendDefinition:
					"Jeder laufende Prozess dieser Definition. Entweder dies oder eine Instanz-ID setzen, nicht beides.",
				sendChannel:
					"Der Name des Ereignisses. Eine Aktion „Ereignis empfangen“ im anderen Prozess empfängt es unter diesem Namen. Namen, die intern reserviert sind (etwa mit cb_ oder attr_ am Anfang), werden abgelehnt.",
				sendData: "Was mit dem Ereignis gesendet wird. Leer: nichts.",
				processOperation:
					"Was die Aktion bei jedem Auslösen eines Eingangs mit einem Prozess tut. Sich selbst zu stoppen, neu zu starten, zu archivieren und zu löschen braucht keine Berechtigung; bei einem anderen Prozess schon.",
				controlTarget:
					"Die ID des Prozesses, auf den die Aktion wirkt, meist aus einem Eingang gelesen. Leer: dieser Prozess selbst.",
				actors: "Nur diese Personen dürfen sie beantworten, ihre Schaltflächen drücken, sie schließen oder ihre Steuerelemente nutzen — ein NotitiaUser, eine Liste davon, eine Benutzer-ID oder E-Mail-Adresse, meist aus einem Attribut gelesen. Leer: alle, die am Prozess mitarbeiten dürfen. Gesetzt, aber ohne Person, etwa bevor ein Verantwortlicher gewählt ist: niemand.",
				accessOperation:
					"Freigeben: einer Person über ihre Rolle hinaus Zugriff auf diesen Prozess geben. Freigabe aufheben: das Gegebene wieder entziehen. Erlaubt, wenn die Person, die diesen Prozess gestartet hat, Prozesse freigeben darf; sonst meldet der Ausgang die Ablehnung.",
				accessUser:
					"Wer: eine Benutzer-ID oder E-Mail-Adresse, oder ein NotitiaUser — aus einem Eingang, einem Attribut oder der Antwort auf eine Frage. Zugriff erhält nur, wer den Dataspace erreichen kann.",
				accessGrant:
					"Darf ansehen: Der Prozess steht in der Liste und lässt sich öffnen. Darf ansehen und mitarbeiten: Die Person darf auch seine Fragen beantworten und seine Daten ändern.",
				listDefinition: "Nur Prozesse dieser Definition.",
				listStatus:
					"Nur Prozesse in diesen Zuständen. Leer: jeder Zustand, auch archivierte.",
				listArchived:
					"An: nur archivierte Prozesse. Aus: nur die übrigen. Ungesetzt: beide.",
				listSearch:
					"Text im Namen oder in der Beschreibung des Prozesses, ohne Beachtung der Groß- und Kleinschreibung.",
				listCreatedBy:
					"Nur Prozesse, die von dieser Benutzer-ID gestartet wurden; ein von einem Prozess gestarteter Prozess erbt sie von diesem.",
				listSpawnedBy: "Nur Prozesse, die diese Prozess-ID gestartet hat.",
				listInstant:
					"Ein Datum mit Uhrzeit und Versatz, wie 2026-03-29T01:30:00Z. Der Anfang zählt mit, das Ende nicht.",
				listSort: "Wonach die Liste geordnet wird.",
				listOrder: "In welcher Richtung die Liste geordnet wird.",
				listLimit: "Höchstens so viele Prozesse, von 1 bis 1000.",
				listOffset: "So viele überspringen, bevor der erste kommt, für die nächste Seite.",
				onTimeMissed:
					"Was mit einem Zeitpunkt geschieht, der verstrich, während der Prozess angehalten war. Ein Prozess, der nie angehalten war, hat nichts verpasst.",
			},
			template: {
				insert: "Wert einfügen",
				insertHint: "Einen Wert einfügen — oder {'{'} im Text tippen",
				placeholder: "Text eingeben; {'{'} fügt einen Wert ein",
				placeholderMultiline: "Den Text eingeben; {'{'} fügt einen Wert ein",
				groups: {
					attr: "Attribute",
					inp: "Eingänge",
					env: "Umgebung",
				},
				kinds: {
					attr: "Attribut",
					inp: "Eingang",
					env: "Umgebungsvariable",
				},
				envCustom: "Umgebungsvariable {name}",
				noMatches: "Keine Treffer. Weiter tippen oder Esc drücken.",
				expression:
					"Dieses Feld enthält einen TypeScript-Ausdruck — die alte Art, Werte in Text zu setzen. Er funktioniert weiter, lässt sich aber erst nach dem Ersetzen wieder als Text bearbeiten.",
				replaceExpression: "Durch Text ersetzen",
				brokenAttribute: "Dieses Datenobjekt hat kein Attribut {name} mehr",
				brokenInput:
					"{name} ist kein Eingang mit einer Quelle — verbinden Sie ihn oder entfernen Sie diesen Wert",
				brokenField:
					"{input} hat kein Feld {field} — wählen Sie ein anderes oder entfernen Sie diesen Wert",
			},
			required: "erforderlich",
			moreActions: "Weitere Aktionen",
			// Oben im Panel genannt, solange ein abgelegter Knoten auf seine Bindung wartet.
			requiredFields: "{fields} ist erforderlich. | {fields} sind erforderlich.",
			sessionModeConditions:
				"Ein Chat nimmt keine Bedingungen an: Er folgt seiner Sitzung. Beim Speichern werden vorhandene Bedingungen entfernt.",
			// Ein eingeklappter Abschnitt, in dem nichts gesetzt ist.
			sections: {
				nothingSet: "Nichts gesetzt",
			},
			tabs: {
				label: "Bereiche der Aktion",
				settings: "Einstellungen",
				question: "Frage",
				answers: "Antworten",
				wiring: "Verknüpfung",
			},
			deleteNodeConfirm: "„{name}“ löschen?",
			deleteNodeNote: "Die Verbindungen dieser Aktion werden mit entfernt.",
			// Von den Antwortzeilen und den Variablenfeldern gemeinsam genutzt.
			unrecognizedValue: "unbekannter Wert",

			identity: {
				name: "Name",
				description: "Beschreibung",
				descriptionPlaceholder: "Beschreibung eingeben…",
				descriptionIconHint:
					"Ein hier geschriebener Iconname (mdi-…) wird zum Icon der Aktion; der Rest wird auf der Aktion angezeigt.",
			},

			attribute: {
				clear: "Attribut leeren",
				write: "Zu schreibendes Attribut",
				listen: "Zu beobachtendes Attribut",
				placeholder: "Attribut wählen…",
				// Der Baum-Auswähler: warum eine eingebettete Liste nicht wählbar ist, und die leere Suche.
				arrayNotSelectable: "Liste von {type} — nicht auswählbar",
				noMatches: "Kein Attribut gefunden.",
				notifyOnFailure: "Bei abgelehntem Schreibvorgang benachrichtigen",
				listenerPort: "Der Ausgang der Aktion trägt den Typ des Attributs.",
				writerPort: "Der Eingang der Aktion nimmt den Typ des Attributs an.",
				notifyOnFailureHint:
					"Wenn aktiviert, erzeugt ein abgelehnter Schreibvorgang (ungültiger Wert oder eine Axiom-Bedingung) zusätzlich eine Benachrichtigung. Unabhängig von dieser Einstellung wird der Fehler immer auf dem eigenen Fehlerkanal dieser Aktion gesendet.",
			},

			event: {
				name: "Name",
				emitted: "Zu sendendes Ereignis",
				listened: "Zu empfangendes Ereignis",
				namePlaceholder: "Ereignisname…",
				nameNotSaved: "Wird gespeichert, sobald das Ereignis einen Typ hat.",
				type: "Ereignistyp",
				typePlaceholder: "Typ wählen…",
				sender: "Zusätzlich ausgeben, wer das Ereignis gesendet hat",
				senderHelp:
					"Fügt einen zweiten Ausgang „sender“ hinzu: die ID und die Definition des Prozesses, der das Ereignis gesendet hat, oder nichts bei einem Ereignis von einer Person oder vom Prozess selbst.",
			},

			lifecycle: {
				title: "Lebenszyklus-Ereignis des Datenobjekts",
				filters: "Filter",
				kinds: {
					CREATED: "Beim Start",
					LOADED: "Beim Laden",
					CREATED_OR_LOADED: "Beim Start oder Laden",
					REMOVED: "Beim Entfernen",
					PROCESS_CHANGED_DATA: "Bei Datenänderung im Prozess",
					DATAOBJECT_CHANGED_DATA: "Bei Datenänderung im Datenobjekt",
				},
				hints: {
					CREATED:
						"Wenn das Datenobjekt entsteht, während der Prozess läuft, oder der Prozess neu startet. Nicht nach einer Fortsetzung: dann entsteht nichts.",
					LOADED: "Wenn das Datenobjekt aus dem gespeicherten Zustand eines Prozesses zurückkommt, der dort weitermacht, wo er aufgehört hat. Nie bei einem frischen Start.",
					CREATED_OR_LOADED:
						"Jedes Mal, wenn das Datenobjekt entsteht, ob der Prozess frisch gestartet oder fortgesetzt wurde. Die Wahl für alles, was ein Prozess öffnet und erneut öffnen muss — einen Voicebot, eine Aktion „SIP: Anrufereignisse“.",
					REMOVED: "Wenn das Datenobjekt entfernt wird.",
					PROCESS_CHANGED_DATA:
						"Bei jeder Änderung an den Daten eines beliebigen Datenobjekts des Prozesses. Was eine Fortsetzung zurückspielt, ist keine Änderung. Liefert die Änderung.",
					DATAOBJECT_CHANGED_DATA:
						"Bei jeder Änderung an den Daten des Datenobjekts dieser Aktivität und der darin eingebetteten Datenobjekte. Liefert die Änderung.",
				},
			},

			code: {
				preview: "Code-Vorschau",
				title: "Code",
				edit: "Code bearbeiten (1 Zeile) | Code bearbeiten ({count} Zeilen)",
				dialogTitle: "Aktionscode",
				clientScriptDialogTitle: "Client-Skript",
				clientScriptRisk:
					"Läuft im eigenen Browserfenster jedes Operators, mit dessen Zugriff. Schreiben Sie nur Code, den Sie selbst ausführen würden.",
				reviewChanges:
					"Vorgeschlagene Änderungen prüfen — hervorgehobene Zeilen wurden geändert",
				decline: "Ablehnen",
				accept: "Übernehmen",
				assistant: "KI-Assistent",
				resizeAssistant: "Breite des KI-Assistenten ändern",
				assistantHint:
					"Beschreiben Sie, was diese Aktion tun soll — der Assistent ändert nur den Code, und Sie können seine Änderungen übernehmen oder ablehnen.",
				promptPlaceholder: "z. B. Eine Begrüßung aus der Eingabe bauen und senden",
				send: "Senden",
				thinking: "Denkt nach…",
				reasoning: "Überlegungen",
				noChanges: "Keine Änderungen nötig.",
				updated: "Code aktualisiert.",
				failed: "Anfrage fehlgeschlagen.",
				notConfigured: "Der KI-Assistent ist auf diesem Server nicht eingerichtet.",
			},

			question: {
				openAnswer: "{name}, {type}, führt zu {target}. Antwort öffnen",
				openUnconnectedAnswer: "{name}, {type}, nicht verbunden. Antwort öffnen",
				body: "Fragetext",
				bodyPlaceholder: "Fragetext eingeben…",
				bodyHint:
					"Markdown. Werte bleiben aktuell, solange die Frage angezeigt wird, außer der Text ist eingefroren.",
				persist:
					"Nach der Beantwortung angezeigt lassen — sie ist dann gesperrt, außer für als änderbar markierte Antworten",
				removeWhenAssigned: "Entfernen, sobald ihre Antworten gespeichert sind",
				removal: {
					title: "Entfernen",
					assignedHelp:
						"Sobald jedes Attribut, in das die Antworten dieser Frage schreiben, einen Wert hat — aus dieser Frage oder von anderswo. 0 und false zählen, leerer Text nicht.",
					waitsFor: "Wartet auf: {attributes}",
					noneAssigned:
						"Keine ihrer Antworten schreibt in ein Attribut, also wartet dies auf nichts.",
					conditionsTitle: "Entfernen, wenn",
					conditionsNone: "Keine Bedingung entfernt sie.",
					dialogNote: "Die Frage entfernen, sobald…",
				},
				output: "Antwort {n}",
				outputTypeHint:
					"Der Typ, den diese Antwort trägt. Schreibt sie in ein Attribut, bestimmt dieses ihn.",
				captions: {
					validation: "Validierung",
					target: "Antwort geht an",
					text: "Text",
					defaultValue: "Standard",
					voice: "Stimme und Vorschläge",
					behaviour: "Verhalten",
				},
				answers: "Antworten",
				addAnswer: "Antwort hinzufügen",
				removeAnswer: "Antwort entfernen",
				reorderAnswer: "Zum Umsortieren ziehen",
				kind: "Art",
				name: {
					empty: "Jede Antwort braucht einen Namen — er ist ihr Schlüssel. Gespeichert wird, sobald sie einen hat.",
					duplicate:
						"Eine andere Antwort dieser Frage hat schon diesen Namen. Gespeichert wird, sobald jede einen eigenen hat.",
				},
				keyPlaceholder: "Name (Schlüssel)",
				labelPlaceholder: "Was die Person gefragt wird",
				datatype: "Antworttyp",
				datatypePlaceholder: "Typ auswählen…",
				datatypeFromAttribute: "Bietet die Werte von {type} an, dem Typ des Attributs.",
				kindFromAttribute: "Vom Attribut festgelegt, in das die Antwort schreibt: {type}.",
				datatypeUseAttribute: "Vom Attribut ({type})",
				display: {
					label: "Darstellung",
					dropdown: "Auswahlliste",
					buttons: "Schaltflächen",
				},
				values: {
					label: "Werte",
					all: "Alle Werte",
					allHint: "Bietet alle Werte dieses Typs an, auch später hinzugefügte.",
					subset: "Nur einige",
					selected: "{selected} von {total}",
					search: "Werte filtern…",
					noMatches: "Keine Werte gefunden.",
					noneTicked:
						"Noch nichts angehakt — solange nichts angehakt ist, wird der ganze Typ angeboten.",
					coversEverything:
						"Alle Werte sind angehakt. Heute dasselbe wie „Alle Werte“, aber später zum Typ hinzugefügte Werte werden nicht angeboten.",
					groups: {
						offered: "Angeboten",
						notOffered: "Nicht angeboten",
					},
					bulk: {
						all: "Alle anhaken",
						none: "Keine anhaken",
						invert: "Umkehren",
					},
				},
				presentation: {
					hint: "Ziehen legt die Reihenfolge fest. Eine hier gesetzte Farbe oder ein Bild gilt nur für diese Frage; gedimmte sind die des Typs.",
					hintFiltered:
						"Zum Ziehen den Filter leeren. Eine hier gesetzte Farbe oder ein Bild gilt nur für diese Frage; gedimmte sind die des Typs.",
					resetOrder: "Reihenfolge zurücksetzen",
					color: "Farbe von {value}",
					clearColor: "Farbe des Typs verwenden",
					reset: "Farbe und Bild des Typs verwenden",
					image: {
						add: "Eigenes Bild verwenden",
						replace: "Bild ersetzen",
						remove: "Bild des Typs verwenden",
					},
				},
				onClickPlaceholder: "JS-Aktion bei Klick (optional)",
				placeholderPlaceholder: "Im leeren Feld angezeigt",
				descriptionPlaceholder: "Hilfe unter dem Feld",
				validation: {
					rule: "Regel {n}",
					noChecks: "Noch keine Prüfung.",
					dialogNote: "Eine Antwort wird angenommen, wenn dies zutrifft.",
					message: "Meldung bei Ablehnung",
					messagePlaceholder: "Angezeigt, wenn diese Regel eine Antwort ablehnt",
					notKept: "Eine Regel braucht eine Prüfung, bevor sie gespeichert wird.",
					noMessage:
						"Keine Meldung: Eine Antwort, die diese Regel ablehnt, wird ohne ein Wort abgewiesen.",
					moveUp: "Regel nach oben",
					moveDown: "Regel nach unten",
					remove: "Regel entfernen",
					none: "Keine Regeln — jede Antwort wird angenommen.",
					add: "Regel hinzufügen",
				},
				fields: {
					label: "Bezeichnung",
					placeholder: "Platzhalter",
					description: "Beschreibung",
					voiceHint: "Sprachhinweis",
				},
				voiceHintPlaceholder: "Wie ein Voicebot dieses Feld erfragen oder bestätigen soll",
				suggestionSource: {
					label: "Vorschläge kommen von",
					auto: "Automatisch",
					provider: "Nur vom Anbieter",
					llm: "Vom LLM",
					none: "Von nirgends",
					hint: "Automatisch: Eine Datenobjekt-Eingabe, deren Typ einen registrierten Anbieter hat (Location), wird von diesem beantwortet, alles andere vom LLM. „Nur vom Anbieter“ fällt nie auf das LLM zurück — kein Anbieter, kein Vorschlag.",
				},
				defaultValue: "Standardwert (optional)",
				defaultExpression: "Standardwert (TS-Ausdruck, optional)",
				historySize: "Größe des Vorschlagsverlaufs (optional, unbegrenzt, wenn leer)",
				disableSuggestions: "Vorschläge deaktivieren",
				skipConfirmation: "Bestätigung überspringen",
				editableAfterCompletion: "Nach Abschluss änderbar",
				editableAfterCompletionHint:
					"Sobald alle Antworten gegeben sind, wird die Frage im Verlauf festgehalten und gesperrt. Eine Antwort mit diesem Haken nimmt weiterhin neue Werte an und kann im Verlauf bearbeitet werden.",
				silentHint:
					"Wenn aktiviert, setzt ein Voicebot den Wert dieser Antwort, ohne ihn vorher mündlich zu bestätigen. Betrifft nur das Verhalten des Voicebots.",
				modeNormal: "Nur den eigenen Ausgang",
				modeAttributeAssigned: "Ein Attribut",
				modeAttributeAssignedHint:
					"Die Antwort wird zusätzlich direkt in das gewählte Attribut geschrieben, über eine Aktion „Attribut schreiben“, die automatisch dafür angelegt wird. Eine Auswahl-Antwort filtert ihre Optionen in diesem Modus live und bietet nur die Werte an, die die Axiome des Attributs gerade zulassen.",
				attributePlaceholder: "Zielattribut wählen…",
				dataobjectPlaceholder: "Datenobjekt wählen…",
				requiredFields: {
					caption: "Pflichtfelder",
					hint: "Eine Antwort ohne eines davon gilt als unvollständig: Sie wird übernommen, die Frage bleibt aber offen, bis der Rest da ist.",
				},
				locationRegion: {
					caption: "Region",
					hint: "Wo der Ortsdienst diese Antwort sucht. Ein Name muss genau so geschrieben sein, wie der Dienst ihn führt, etwa Saarland oder Thueringen; ein Name, den er nicht kennt, beschränkt nichts.",
					inherit: "Die Region des Prozesses",
					anywhere: "Ganz Deutschland",
					named: "Eine Region",
					placeholder: "Saarland",
				},
				kinds: {
					text: "Text",
					number: "Zahl",
					boolean: "Ja/Nein",
					select: "Auswahl",
					button: "Schaltfläche",
					dataobject: "Datenobjekt",
				},
			},

			ports: {
				inputs: "Eingänge",
				outputs: "Ausgänge",
				addType: "Typ hinzufügen…",
				untyped: "ohne Typ",
				unconnected: "nicht verbunden",
				disconnect: "Trennen",
				removeInput: "Eingang entfernen",
				dismissed: "geschlossen",
				reserved: "Fest eingebaut — dieser Eingang lässt sich weder entfernen noch ändern.",
				removeOutput: "Ausgang entfernen",
				outputNamePlaceholder: "Name…",
				outputNameHint: "Optionaler Name des Ausgangs (nur beschreibend)",
				outputNameEmitHint: "Der Name, unter dem das Skript auf diesen Ausgang sendet",
				unnamedOutputs:
					"Ein Ausgang ohne Namen ist nicht erreichbar: Das Skript sendet auf einen Ausgang über seinen Namen.",
				repeatedOutputNames:
					"Mehr als ein Ausgang heißt {names} — das Skript erreicht einen Ausgang über seinen Namen, also braucht jeder einen eigenen.",
				changeType: "{type} — zum Ändern des Typs klicken",
				connectedHint: "Verbunden — trennen Sie die Eingänge, um den Typ zu ändern",
				inputConnectedHint:
					"Verbunden — trennen Sie diesen Eingang, um seinen Typ zu ändern",
				addControl: "Steuereingang hinzufügen…",
				// Was das Auslösen eines Steuereingangs bewirkt: sein Tooltip und seine Zeile im Menü, das ihn hinzufügt.
				controls: {
					start: "Startet die Aktion",
					stop: "Hält die Aktion an",
					hangup: "Legt auf",
					transfer:
						"Leitet den Anruf an das ankommende Ziel weiter, sonst an das Weiterleitungsziel",
					call: "Ruft das ankommende Ziel aus dem Anruf heraus an",
					reset: "Setzt den Zähler auf null zurück",
					cancel: "Hält an, ohne auszulösen",
				},
			},

			vars: {
				value: "Wert",
				numberPlaceholder: "0",
				expressionPlaceholder: '"Hallo " + wert',
				shortTextPlaceholder: "Text",
				envPlaceholder: "ENV_NAME",
				attributePlaceholder: "Attribut wählen…",
				noConnectedInputs: "keine verbundenen Eingänge",
				unset: "Standard",
				unsetDefault: "Standard ({value})",
				unsetNone: "Nicht gewählt",
				unsetAnyProcess: "Jeder Prozess",
				selectPlaceholder: "wählen…",
				templateKind: "Vorlage",
				expressionOn: "Wird als Ausdruck bearbeitet — zurück zu reinem Text",
				expressionOff: 'Als Ausdruck bearbeiten (z. B. "Hallo " + wert)',
				// Die Var-Specs der Registry, nach dem Schlüssel, den ihr `labelKey` nennt.
				labels: {
					suggestionValue: "Wert",
					poolEntries: "Karten",
					chatRoles: "Rollennamen",
					freezeText: "Text beim Anzeigen einfrieren",
					interactableId: "ID des interaktiven Elements",
					panel: "Panel",
					panelTitle: "Titel",
					panelColumn: "Spalte",
					panelAlign: "Ausrichtung",
					chatTitle: "Titel",
					onDismiss: "Entfernbar",
					chatLanguages: "Operatoren können die Sprache jeder Rolle festlegen",
					chatComposer: "Operatoren können Nachrichten schreiben",
					chatPrefabs: "Operatoren können Prefabs senden",
					chatPlay: "Operatoren können die Sprachausgabe abspielen",
					chatSummary: "Zusammenfassung anzeigen",
					voiceProvider: "Stimmanbieter",
					voiceGender: "Stimmgeschlecht",
					voiceInstructions: "Sprechanweisungen",
					body: "Text",
					severity: "Schweregrad",
					color: "Farbe",
					icon: "Icon",
					attribute: "Attribut",
					explanation: "Erklärung",
					dataobjectId: "Datenobjekt-ID",
					title: "Titel",
					address: "Adresse",
					displayKind: "Anzeigeart",
					sender: "Absender",
					emitImmediately: "Sprachausgabe automatisch abspielen",
					sessionId: "Sitzungs-ID",
					alternisApiBase: "Alternis-URL",
					alternisToken: "Alternis-Token",
					questionBody: "Text (Markdown)",
					persist: "Beibehalten",
					questionTab: "Tab",
					questionGroup: "Gruppe",
					priority: "Priorität",
					tabId: "Tab-ID",
					questionId: "Fragen-ID",
					message: "Nachricht",
					level: "Stufe",
					systemPrompt: "System-Prompt",
					language: "Sprache",
					languageLock: "Sprachbindung",
					botRole: "Bot-Rolle (Alternis-Rollen-ID)",
					callerRole: "Anruferrolle (erste Annahme, wird automatisch gelernt)",
					showChat: "Chat anzeigen",
					llmGatewayUrl: "LLM-Gateway-URL",
					llmModel: "LLM-Modell",
					llmApiKey: "LLM-Gateway-Token",
					llmTimeout: "LLM-Timeout (ms)",
					debugLogging: "Debug-Logging",
					voiceMode: "Sprechweise",
					offPath: "Wenn der Anrufer abschweift",
					floorPolicy: "Wer sprechen darf",
					silenceTimeout: "Timeout bei Stille (ms)",
					reaskMax: "Versuche pro Frage",
					greeting: "Begrüßung",
					closing: "Verabschiedung",
					questionScope: "Fragenbereich (Tab)",
					spokenText: "Gesprochener Text",
					questionReaskMax: "Versuche, bevor es weitergeht",
					reaskRephrase: "Beim Nachfragen umformulieren",
					questionOptional: "Optional — der Anruf kann ohne Antwort abgeschlossen werden",
					locationServiceUrl: "URL des Ortsdienstes",
					locationServiceTimeout: "Timeout (ms)",
					locationServiceRegion: "Region",
					locationServicePhone: "Telefonnummer",
					locationServiceLat: "Breitengrad",
					locationServiceLon: "Längengrad",
					locationServiceRadius: "Genauigkeitsradius (m)",
					suggestionsEnabled: "Vorschläge aktiviert",
					messageText: "Nachrichtentext",
					prefabId: "Prefab-ID",
					sipNumbers: "Rufnummern",
					sipAction: "Aktion",
					callId: "Anruf-ID",
					sipNumber: "Rufnummer",
					sipExtension: "Nebenstelle",
					sipReference: "Referenz",
					sipStatus: "Status bei Abweisung",
					alternisIntegration: "Alternis-Anbindung",
					bargeIn: "Barge-in",
					bargeInGraceMs: "Barge-in-Karenzzeit (ms)",
					bargeInDuck: "Satz leiser stellen, während der Anrufer spricht",
					bargeInMinWords: "Wörter, bevor der Bot abbricht",
					cueThinking: "Denkgeräusch abspielen",
					cueListening: "Ton abspielen, wenn der Anrufer an der Reihe ist",
					cueMute:
						"Töne abspielen, wenn der Anrufer stumm- und wieder hörbar geschaltet wird",
					transferTarget: "Weiterleitungsziel",
					locationCallerNumber: "Nummer des Anrufers an den Ortsdienst senden",
					pathPrefix: "Nur unterhalb dieses Pfads",
					changeKinds: "Nur diese Änderungen",
					excludeOrigins: "Änderungen ignorieren von",
					dataobjectOperation: "Operation",
					concept: "Datenobjekt",
					template: "Vorlage",
					embedPath: "Einbettungsstelle",
					relation: "Beziehung",
					targetId: "Datenobjekt-ID",
					operationData: "Startdaten",
					ownerId: "Zu bearbeitendes Datenobjekt (ID)",
					ownerConcept: "Konzept dieses Datenobjekts",
					interval: "Alle (ms)",
					tickLimit: "Anhalten nach (Takten)",
					timeout: "Nach (ms)",
					retrigger: "Beim Start während des Laufs",
					passthrough: "Startwert weitergeben",
					schedule: "Zeitplan",
					at: "Datum und Uhrzeit",
					timeOfDay: "Uhrzeit",
					weekdays: "An diesen Tagen",
					timezone: "Zeitzone",
					missed: "Bei verpasstem Zeitpunkt",
					processDefinition: "Prozess",
					instanceName: "Name des neuen Prozesses",
					instanceDescription: "Beschreibung des neuen Prozesses",
					restartRule: "Neustartregel",
					seed: "Start-Datenobjekte",
					targetProcessId: "Instanz-ID",
					targetDefinition: "Jeder laufende Prozess von",
					eventChannel: "Ereignisname",
					eventData: "Daten",
					processOperation: "Operation",
					controlTarget: "Prozess-ID",
					actors: "Personen",
					accessOperation: "Operation",
					accessUser: "Person",
					accessGrant: "Zugriff",
					listStatus: "Status",
					listArchived: "Archiviert",
					listSearch: "Text",
					listCreatedBy: "Gestartet von (Benutzer-ID)",
					listSpawnedBy: "Gestartet von (Prozess-ID)",
					listCreatedFrom: "Erstellt ab",
					listCreatedTo: "Erstellt vor",
					listUpdatedFrom: "Geändert ab",
					listUpdatedTo: "Geändert vor",
					listSort: "Sortieren nach",
					listOrder: "Reihenfolge",
					listLimit: "Höchstens",
					listOffset: "Überspringen",
				},
				options: {
					languageLockSoft: "Weich — passt sich dem Anrufer an",
					languageLockHard: "Hart — immer diese Sprache",
					changeKinds: {
						attribute: "Ein Wert geschrieben",
						embedded_created: "Ein eingebettetes Datenobjekt hinzugefügt",
						embedded_removed: "Ein eingebettetes Datenobjekt entfernt",
						relation_linked: "Eine Beziehung verknüpft",
						relation_unlinked: "Eine Beziehung gelöst",
					},
					changeOrigins: {
						reasoning: "Der Prozess selbst",
						user: "Eine Person",
						external: "Der Host oder die API",
						axiom_inferred: "Ein Axiom",
					},
					weekdays: {
						mon: "Mo",
						tue: "Di",
						wed: "Mi",
						thu: "Do",
						fri: "Fr",
						sat: "Sa",
						sun: "So",
					},
					dataobjectOperations: {
						create: "Datenobjekt erzeugen",
						create_embedded: "Eingebettetes Datenobjekt erzeugen",
						create_related: "Verbundenes Datenobjekt erzeugen",
						link_related: "Verbundenes Datenobjekt verknüpfen",
						unlink_related: "Verbundenes Datenobjekt lösen",
					},
					retrigger: { restart: "Ab jetzt neu zählen", ignore: "Weiterlaufen lassen" },
					panelColumn: { left: "Links", middle: "Mitte", right: "Rechts" },
					panelAlign: { top: "Oben", bottom: "Unten" },
					removable: {
						none: "Nein",
						remove: "Ja, entfernen",
						output: "Ja, Ausgang auslösen",
					},
					schedule: {
						once: "Einmal, an einem Datum und einer Zeit",
						daily: "Täglich, zu einer Uhrzeit",
					},
					missed: { skip: "Vergessen", fire_once: "Einmal für den neuesten auslösen" },
					restartRules: {
						"by-user": "Nur auf Wunsch einer Person",
						"unless-stopped": "Immer, außer gestoppt",
						"on-failure": "Bei einem Fehler",
						no: "Nie",
					},
					accessOperations: {
						grant: "Freigeben",
						revoke: "Freigabe aufheben",
					},
					accessGrants: {
						read: "Darf ansehen",
						read_write: "Darf ansehen und mitarbeiten",
					},
					processOperations: {
						stop: "Stoppen",
						restart: "Neu starten",
						archive: "Archivieren",
						unarchive: "Dearchivieren",
						delete: "Löschen",
					},
					processStatuses: {
						starting: "Startet",
						running: "Läuft",
						stopped: "Gestoppt",
						failed: "Fehlgeschlagen",
						archived: "Archiviert",
					},
					processSorts: {
						created_at: "Erstellt",
						updated_at: "Zuletzt geändert",
						name: "Name",
						status: "Status",
						definition: "Definition",
					},
					processOrders: {
						asc: "Aufsteigend",
						desc: "Absteigend",
					},
				},
			},
		},

		droppedConnections: {
			one: "Verbindung von {output} zu „{node}“ entfernt: Der Eingang {input} nimmt {inputType} an, nicht {outputType}.",
			many: "{n} Verbindungen entfernt, deren Eingänge den Typ ihrer Quelle nicht mehr annehmen.",
		},
		conditions: {
			title: "Bedingungen",
			add: "Bedingung hinzufügen",
			addRule: "Regel hinzufügen",
			remove: "Bedingung entfernen",
			none: "Wird immer ausgeführt — keine Bedingungen gesetzt.",
			removesOnFail:
				"Löst die Aktion aus und gelten diese Bedingungen nicht, wird entfernt, was sie gerade zeigt — wie über ihren Eingang „remove“.",
			generatedCode: "Generierter Code",
			dialogTitle: "Bedingung hinzufügen",
			dialogSubtitle: "Diese Aktion nur ausführen, wenn…",
			if: "wenn",
			theAnswer: "die Antwort",
			answerKind: "Gegenstand",
			// Vor jeder Regel nach der ersten: ein Etikett, das dem einen Operator der Gruppe folgt.
			joinAnd: "und",
			joinOr: "oder",
			typeIssue: {
				operator: "Diese Prüfung passt nicht zum aktuellen Typ des Eingangs.",
				value: "Der Wert passt nicht zum aktuellen Typ des Eingangs.",
				input: "Der andere Eingang lässt sich nicht mehr mit dem Typ dieses Eingangs vergleichen.",
			},
			operatorLabel: "Regeln verknüpfen mit",
			operatorAnd: "UND",
			operatorOr: "ODER",
			edit: "Bedingung bearbeiten",
			editDialogTitle: "Bedingung bearbeiten",
			saveRule: "Regel speichern",
			subjectKind: "Art des Subjekts",
			valueKind: "Art des Werts",
			operator: "Operator",
			value: "Wert",
			input: "Eingang",
			comparedInput: "Verglichener Eingang",
			comparedEnv: "Verglichene Umgebungsvariable",
			envName: "Name der Umgebungsvariable",
			fixedValue: "Fester Wert",
			attributePlaceholder: "Attribut…",
			inputPlaceholder: "Eingang…",
			envPlaceholder: "VAR_NAME",
			valuePlaceholder: "Wert…",
			choosePlaceholder: "wählen…",
			emptyPlaceholder: "—",
			noInputs: "keine Eingänge",
			noCompatibleInputs: "keine passenden Eingänge",
			// Suffix der Überlaufmarkierung auf der Zeichenfläche: „… +2 weitere“.
			more: "weitere",
			sources: {
				attr: "Attribut",
				inp: "Eingang",
				env: "Umgebungsvariable",
				lit: "Wert",
			},
			kinds: {
				string: "Text",
				number: "Zahl",
				boolean: "ja / nein",
				array: "Liste",
				enum: "Option",
			},
			operators: {
				isDefined: "ist gesetzt",
				isNotDefined: "ist nicht gesetzt",
				isEmpty: "ist leer",
				isNotEmpty: "ist nicht leer",
				isEqual: "gleich",
				isNotEqual: "ungleich",
				isGreaterThan: ">",
				isLessThan: "<",
				isGreaterThanOrEqual: "≥",
				isLessThanOrEqual: "≤",
				contains: "enthält",
			},
		},
	},
};
